import cn from 'classnames';
import { NavLink } from 'react-router-dom';

import { NavFavorite } from '../NavSection';

import s from './FavoritesSection.module.scss';

type Props = {
  title: string;
  links: NavFavorite[];
  emptyText: string;
  onNavigate: (event: React.MouseEvent<HTMLAnchorElement>) => void;
};

const FavoritesSection: React.FC<Props> = ({ title, links, emptyText, onNavigate }) => (
  <section className={s.section}>
    <h4 className={s.section__title}>{title}</h4>
    {links.length === 0 && <p className={s.section__empty}>{emptyText}</p>}
    <ul className={s.section__list}>
      {links.map((link) => (
        <li key={link.id}>
          <NavLink
            to={link.to}
            className={({ isActive }) => cn(s.section__link, isActive && s.section__link_active)}
            title={link.label}
            onClick={onNavigate}
          >
            {link.label}
          </NavLink>
        </li>
      ))}
    </ul>
  </section>
);

export { FavoritesSection };
